'use strict';

export default class GrpTransactionListCtrl {
  data;

  constructor($stateParams, $location, $filter, LoaderSvc, moment, DatetimeSvc,
    GroupSvc, GroupAuthSvc, GrpTxnSvc, FinTxnSvc) {
    LoaderSvc.start('Loading Group Transactions...');
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId; // set for group urls
    var groupId = $stateParams.groupId;
    this.groupId = groupId; // set for group urls

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'groupTransaction', 'I');

    that.dataModel = 'gtvm';

    that.payPeriods = [];
    that.finTransactions;
    that.groupTransactions;
    that.memberTransactions = [];

    // 1. get time periods
    GroupSvc.getTimePeriods({groupId: ctxId}).$promise
      .then(function(tp) {
      // ignore values that haven't started yet - without effective start
        var today = moment();
        tp = tp.filter(function(per) {
        // enable payment for effective periods
          var tpEnd = per.effectiveEnd || per.end;
          tpEnd = DatetimeSvc.parseUTCDate(tpEnd, true);
          if(today.isSameOrBefore(tpEnd)) { that.payPeriods.push(per.id); }

          return per.effectiveStart
          && today.isSameOrAfter(DatetimeSvc.parseUTCDate(per.effectiveStart));
        });
        // tp.push({id: '', name: 'All Years'});
        tp = $filter('orderBy')(tp, 'start', true);
        // initialize time periods with current time period
        // refresh filter with updates to query params
        for(var i = 0; i < tp.length; i++) {
          var per = tp[i];
          // set default filter
          var effectiveStart = per.effectiveStart || per.start;
          if(today.isSameOrAfter(effectiveStart)
        && today.isSameOrBefore(DatetimeSvc.parseUTCDate(per.end, true))) {
            that.tpFilter = per.id;
            break;
          }
        }
        that.timePeriods = tp;
      })
      .then(function() {
      // 2. get transactions
        return GrpTxnSvc.query({groupId}).$promise
          .then(function(gt) {
            // map time periods for filtering
            gt.forEach(function(d) {
              if(d.utcDate) {
                var m = moment(d.utcDate).utcOffset(0);
                var dateStr = m.format('YYYY-MM-DD');
                d.date = moment(dateStr).valueOf();
              }
            });
            that.groupTransactions = gt;
            that.order = 'date';
            that.searchField = 'name';
          })
          .catch(function() {
            LoaderSvc.stopError('Error loading Group Transactions');
          });
      })
      .then(function() {
      // 3. get member transactions
        return that.getMemberTxn(that.tpFilter);
      })
      .then(function() {
      // 4. get financial transactions
        return FinTxnSvc.query({groupId}).$promise
          .then(function(ft) {
            // map time periods for filtering
            ft = ft.map(function(d) {
              if(d.utcDate) {
                var m = moment(d.utcDate).utcOffset(0);
                var dateStr = m.format('YYYY-MM-DD');
                d.date = moment(dateStr).valueOf();
              }
              // if(d.rejectedAt) {
              //   d.status = 'Rejected';
              // } else if(d.acceptedAt) {
              //   d.status = 'Accepted';
              // } else if(d.submittedAt) {
              //   d.status = 'Submitted';
              // }
              return d;
            });
            that.finTransactions = ft;
            that.filterGrpTxn();
            that.order = 'date';
            that.searchField = 'name';
            LoaderSvc.stop();
          })
          .catch(function() {
            LoaderSvc.stopError('Error loading Financial Transactions');
          });
      });

    // cache and retrieve member transactions
    that.memberTxnByTimePeriod = {};
    that.memberTxnByTimePeriod[-1] = [];
    that.includesNullTimePeriods = false;
    that.getMemberTxn = function(timePeriodId) {
      return GrpTxnSvc.queryMembers({groupId, tpId: that.tpFilter}).$promise
        .then(function(mt) {
        // map time periods for filtering
          mt.forEach(function(d) {
            if(d.utcDate) {
            //eslint-disable-next-line newline-per-chained-call
              var dateStr = moment(d.utcDate).utcOffset(0).format('YYYY-MM-DD');
              d.date = moment(dateStr).valueOf();
            }
          });

          // add transactions for the time period
          that.memberTxnByTimePeriod[timePeriodId]
        = $filter('filter')(mt, {timePeriodId});

          // add transactions unassociated with any time period (only once)
          if(!that.includesNullTimePeriods) {
            that.includesNullTimePeriods = true;
            that.memberTxnByTimePeriod[-1] = [];
            // eslint-disable-next-line no-undef
            angular.forEach(mt,
              function(memTxn) {
                if(!memTxn.timePeriodId || !memTxn.timePeriod.id) {
                  that.memberTxnByTimePeriod[-1].push(memTxn);
                }
              });
          }
        })
        .then(function() {
          that.order = 'date';
          that.searchField = 'name';
        })
        .catch(function() {
          LoaderSvc.stopError('Error loading Member Transactions');
        });
    };

    that.filterGrpTxn = function() {
      that.finData = $filter('filter')(that.finTransactions,
        {timePeriodId: that.tpFilter});
      that.groupData = $filter('filter')(that.groupTransactions,
        {timePeriodId: that.tpFilter});

      if(!that.memberTxnByTimePeriod[that.tpFilter]) {
        // get and set memberTxn
        that.getMemberTxn(that.tpFilter)
          .then(function() {
            that.memberData = that.memberTxnByTimePeriod[that.tpFilter].concat(
              that.memberTxnByTimePeriod[-1]
            );
          });
      } else {
        // get memberTxn from cache
        that.memberData = that.memberTxnByTimePeriod[that.tpFilter].concat(
          that.memberTxnByTimePeriod[-1]
        );
      }
    };
  }
}

GrpTransactionListCtrl.$inject = [
  '$stateParams',
  '$location',
  '$filter',
  'LoaderSvc',
  'moment',
  'DatetimeSvc',
  'GroupSvc',
  'GroupAuthSvc',
  'GrpTxnSvc',
  'FinTxnSvc'
];
